module.exports = __webpack_public_path__ + "img/nic-ni-logo.593a6562.svg";